import { Grid } from "@material-ui/core";
import { InputReactDatepicker, Modal, MasterButton } from "App/Component/ui";
import {
  today,
} from "App/utils/helpers";
import React, { useState } from "react";
import { usePrintPdf } from "./helpers";

const RESET_STATE_PDF = {
  id: "",
  tanggal_surat: today(),
  tanggal_kirim: today(),
};

function ModalPDF({ setShowModal, id, datas }) {
  const { handleClickPDF, loadingPrint } = usePrintPdf();
  const [formData, setFormData] = useState({
    ...RESET_STATE_PDF,
    id,
  });
  return (
    <Modal title={`CETAK PDF`} show={setShowModal}>
      <form>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputReactDatepicker
              selected={formData.tanggal_surat}
              label="TANGGAL CETAK SURAT"
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal_surat: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal_surat: e,
                })
              }
            />
          </Grid>
          <Grid item sm={12}>
            <InputReactDatepicker
              selected={formData.tanggal_kirim}
              label="TANGGAL KIRIM SURAT"
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal_kirim: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal_kirim: e,
                })
              }
            />
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            style={{
              gap: "1rem",
            }}
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="button"
              color={loadingPrint ? "secondary" : "green"}
              name={loadingPrint ? "Loading..." : "CETAK PDF"}
              onClick={() => (loadingPrint ? null : handleClickPDF(formData, datas))}
              size="md"
            />
          </Grid>
        </Grid>
      </form>
    </Modal>
  );
}

export default ModalPDF;
;
